export const ORIGIN_INSTALLATION_ADDRESS = "Vrbové, Slovakia";
